import React from "react"
import clsx from "clsx"

type AvatarProps = React.HTMLAttributes<HTMLDivElement>

export function Avatar({ className, ...props }: AvatarProps) {
  return (
    <div
      className={clsx(
        "relative flex h-10 w-10 shrink-0 overflow-hidden rounded-full",
        className
      )}
      {...props}
    />
  )
}

type AvatarImageProps = React.ImgHTMLAttributes<HTMLImageElement>

export function AvatarImage({ className, ...props }: AvatarImageProps) {
  return (
    <img
      className={clsx("h-full w-full object-cover", className)}
      {...props}
    />
  )
}

type AvatarFallbackProps = React.HTMLAttributes<HTMLDivElement>

export function AvatarFallback({ className, children, ...props }: AvatarFallbackProps) {
  return (
    <div
      className={clsx(
        "flex h-full w-full items-center justify-center rounded-full bg-slate-200 text-xs font-semibold text-slate-700",
        className
      )}
      {...props}
    >
      {children}
    </div>
  )
}
